import React from "react";
import {connect} from "react-redux";
import BasicModal from "../../../components/common/BasicModal";
import {basicForm} from "../../../utils/helpers";
import {FormattedMessage} from "react-intl";
import {endEditBreakTagAction, submitBreakTagEditAction, updateBreakTagFieldError} from "./actions";

const formConfig = {

    fields: [
        {
            name: "label",
            type: "text",
            required: true,
            props: {
                label: <FormattedMessage id="breakTagModal.label"/>,
                validateInitialValue: true,
                validateOnChange: true,
                validationRules: [
                    {
                        type: 'PermalinkFormat',
                    }
                ]
            }
        },
        {
            name: "translations",
            subSection: true,

            fields: [
                {
                    name: "en-US",
                    type: "text",
                    props: {
                        label: <FormattedMessage id="breakTagModal.translations.en-US"/>
                    }
                },
                {
                    name: "es-LA",
                    type: "text",
                    props: {
                        label: <FormattedMessage id="breakTagModal.translations.es-LA"/>
                    }
                },
                {
                    name: "en-GB",
                    type: "text",
                    props: {
                        label: <FormattedMessage id="breakTagModal.translations.en-GB"/>
                    }
                }
            ]
        }
    ]
};

const Form = basicForm(formConfig);

const BreakTagModal = (props) => {

    return (
        <BasicModal header={"Edit Tag"}
                    open={props.open}
                    onClose={props.endEdit}
                    specialType="primary-modal"
                    actions={[
                        {
                            label: props.editing ? "Save" : "Create",
                            isDisabled: !props.canSubmit,
                            displayType: "button",
                            action: props.submit,
                            loading: props.processing
                        },
                    ]}>
            <Form
                data={props.tag}
                onValidationError={(resourcePath, fieldPath, value) => props.updateError(fieldPath.join("."), true)}
                onValueChanged={(resourcePath, fieldPath, value) => props.updateError(fieldPath.join("."), false, value)}/>
        </BasicModal>
    );
};

const mapState = ({breakTagModal}) => {
    let errorKeys = Object.keys(breakTagModal.fieldErrors);
    let hasErrors = false;
    let editing = breakTagModal.editingTag;

    for (let key of errorKeys) {
        if (breakTagModal.fieldErrors[key] === true) {
            hasErrors = true;
            break;
        }
    }
    return {
        open: breakTagModal.editingTag || breakTagModal.creatingTag,
        canSubmit: !hasErrors,
        tag: breakTagModal.tag,
        editing,
        processing: breakTagModal.submitting,
    };
};

const mapDispatch = (dispatch) => {
    return {
        submit: () => dispatch(submitBreakTagEditAction()),
        endEdit: () => dispatch(endEditBreakTagAction()),
        updateError: (field, error, value) => dispatch(updateBreakTagFieldError(field, error, value))
    };
};

const BreakTagModalConnected = connect(mapState, mapDispatch)(BreakTagModal);

export default BreakTagModalConnected;



// WEBPACK FOOTER //
// ./public/pages/EditBreak/BreakTagModal/BreakTagModal.jsx